<template>
  <v-dialog v-model="dialog" max-width="420px" persistent>
    <div class="modal-wrapper">
      <img src="@/assets/bg-cta.png" alt="Background" class="modal-background" />
      
      <div class="modal-content">
        <v-btn icon class="close-btn" @click="closeModal" dark>
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <h2 class="modal-title">
          Garanta sua vaga agora e venha descobrir o que o Estado pode estar te devendo.
        </h2>
        
        <p class="modal-subtitle">
          Vagas limitadas para garantir um encontro direto e esclarecedor.
        </p>

        <h3 class="form-title">Quero garantir minha vaga:</h3>

        <v-form ref="form" v-model="valid" class="modal-form">
          <v-text-field
            v-model="formData.nome"
            label="nome completo"
            :rules="[rules.required]"
            outlined
            dense
            dark
            class="form-field"
          ></v-text-field>

          <v-text-field
            v-model="formData.email"
            label="e-mail"
            :rules="[rules.required, rules.email]"
            outlined
            dense
            dark
            class="form-field"
          ></v-text-field>

          <v-text-field
            v-model="formData.whatsapp"
            label="whatsapp"
            :rules="[rules.required, rules.phone]"
            outlined
            dense
            dark
            class="form-field"
            v-mask="'(##) #####-####'"
          ></v-text-field>

          <v-btn
            class="submit-btnx"
            large
            block
            @click="submitFormx"
            :disabled="!valid"
          >
            Concluir inscrição
          </v-btn>
        </v-form>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { VueMaskDirective } from 'v-mask'
const API_BASE = 'https://pmariante.pythonanywhere.com'

export default {
  directives: {
    mask: VueMaskDirective
  },
  name: 'ConfirmacaoModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    visible(newVal) {
      this.dialog = newVal;
    },
    dialog(newVal) {
      if (!newVal) {
        this.$emit('update:visible', false);
      }
    }
  },
  
  data() {
    return {
      dialog: false,
      valid: false,
      confirmado: false,
      formData: {
        nome: '',
        email: '',
        whatsapp: ''
      },
      rules: {
        required: value => !!value || 'Campo obrigatório',
        email: value => {
          const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          return pattern.test(value) || 'E-mail inválido';
        },
        phone: value => {
          const pattern = /^[\d\s()-]+$/;
          return pattern.test(value) || 'Telefone inválido';
        }
      }
    };
  },

  methods: {
    openModal() {
      this.dialog = true;
    },
    
    closeModal() {
      this.dialog = false;
      this.resetForm();
    },
    
    resetForm() {
      this.formData = {
        nome: '',
        email: '',
        whatsapp: ''
      };
      if (this.$refs.form) {
        this.$refs.form.reset();
      }
    },
    
    submitFormx() {
      if (this.$refs.form.validate()) {
        // Aqui você pode adicionar a lógica para enviar os dados
        console.log('Formulário enviado:', this.formData);
        this.$emit('submitted', this.formData);
        this.confirmarPresenca();
      }
    },

    confirmarPresenca () {
      // Gerar data e hora atual formatada
      const agora = new Date();
      const dataHoraFormatada = agora.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
      
      this.$http.post(`${API_BASE}/confirmarPalestra`, { 
        nome: this.formData.nome, 
        email: this.formData.email, 
        whatsapp: this.formData.whatsapp, 
        dataInscricao: dataHoraFormatada 
      })
        .then(() => {
          localStorage.setItem('meuNome', this.formData.nome)
          this.confirmado = true
          this.closeModal();
        })
        .catch(err => {
          console.error('Erro ao confirmar presença:', err);
          this.closeModal();
        })
    },
  }
};
</script>

<style scoped>
.modal-wrapper {
  position: relative;
  overflow: hidden;
  border-radius: 4px;
}

.modal-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}

.modal-content {
  position: relative;
  z-index: 1;
  padding: 40px 30px;
  color: white;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 2;
}

.modal-title {
  font-size: 18px;
  font-weight: 700;
  line-height: 1.3;
  margin-bottom: 16px;
  color: white;
}

.modal-subtitle {
  font-size: 16px;
  line-height: 1.4;
  margin-bottom: 24px;
  color: white;
}

.form-title {
  font-size: 20px;
  font-weight: 400;
  margin-bottom: 24px;
  color: #D4B896;
}

.modal-form {
  margin-top: 20px;
}

.form-field {
  margin-bottom: 16px;
}

.form-field >>> .v-input__control {
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 4px;
}

.form-field >>> .v-label {
  color: rgba(0, 0, 0, 0.6) !important;
  font-size: 14px;
}

.form-field >>> .v-text-field__slot input {
  color: #000;
}

.submit-btnx {
  background-color: #B8956A !important;
  margin-top: 20px;
  font-weight: 700;
  text-transform: none;
  letter-spacing: 0.5px;
  color: white !important;
}
</style>